import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The atlas hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a warm rust + amber palette for a steady,
 * strong-hearted protector. Choosing him recolours the WHOLE kid shell: the brand ramp drives buttons /
 * meters / rings in terracotta, the canvas blooms warm to a peach+stone dawn, and the hero stage takes his
 * canyon-dusk sky. Every brand colour is paired with its own foreground for legibility.
 */
export const atlasTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — burnt terracotta. `soft`→`primary` is the button/meter gradient (white text); `deep` is
  // on-light text; `tint` is the softest fill; `glow-rgb` = #B75B2C for coloured shadows.
  '--color-primary': '#B75B2C',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#D37E4B',
  '--color-primary-deep': '#8A3F1A',
  '--color-primary-tint': '#FBE7DB',
  '--color-primary-glow-rgb': '183 91 44',
  '--color-secondary': '#E8DED6',
  '--color-secondary-fg': '#4A3A2E',
  '--color-accent': '#E8A93B',
  '--color-accent-fg': '#4A3200',
  // CANVAS — a soft peach bloom top-left, a warm stone bloom bottom-right (a canyon-dawn behind the content).
  '--canvas-a': '#F7E3D3',
  '--canvas-b': '#EFE6DC',
  // A deep canyon dusk (plum-to-sienna-to-gold), white text stays AA over it.
  '--sky-top': '#3a2540',
  '--sky-mid': '#8a4a3a',
  '--sky-low': '#e0a868',
  '--sky-glow': '#ffd9a0',
  '--sky-fg': '#ffffff',
});
